export default __webpack_public_path__ + "static/media/finger-pointing.13b76495.png";